import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router/clean";
import storeTs from "./storeTs";
import ElementPlus from "element-plus";
import locale from "element-plus/lib/locale/lang/es";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import utils from "./utils";
import "@/core/plugins/prismjs";

import { es } from "yup-locales";
import { setLocale } from "yup";

const app = createApp(App);

app.use(storeTs);
app.use(router);
app.use(ElementPlus, {
  locale,
});

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();
setLocale(es);
utils(app);

app.use(i18n);

app.mount("#app");
